import { Observable } from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

// an interface forces another component to act on the method inside the interface in this case forcing
// what is inside here to act on it

// needs the connection between guard and component to conncet everything
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

// this is set up that allows component to conncet to CanDeactivateGuard
export class canDeactivateGuard  {
  // required by angular calling the interface to react
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate();
  }
}
